exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-282974cc]{text-align:center}h5[data-v-282974cc]{font-size:17px}.poll__content[data-v-282974cc]{width:100%;text-align:center;padding:10px 0 0 0}.btn--poll[data-v-282974cc]{border-radius:10px;border:1px solid #c1c3c6}.accept[data-v-282974cc]{color:#fff;background:#f06b71}", ""]);

// exports
